export default __webpack_public_path__ + "static/media/image-event-test.9a63662f.jpg";